import { StockVm } from "./stockVm";
import { changeLuminosity, getWhiteBlackForegroundFromBackgroundColor, IFertiliserStock, nutrition } from "../omnia";
import { NutrientType, StockType } from "@omnia/shared/generated/enums";

export class FertiliserStockVm extends StockVm {

    constructor(private fertiliser: IFertiliserStock) {
        super(fertiliser, StockType.Fertiliser);
    }

    get icon(): string {
        return "stock-fertiliser";
    }

    getColor(): number[] {

        var nutrient = this.getMainNutrient();

        if (nutrient) {

            var color = nutrition.colors.getNutrientBaseColor(nutrient);

            var tooDark = getWhiteBlackForegroundFromBackgroundColor(color);

            if (tooDark) {
                color = changeLuminosity(color, 1.3);
            } else {
                color = changeLuminosity(color, 0.7);
            }

            return color;
        }

        return [224, 224, 224];
    }

    hasProduct(): boolean {
        return this.fertiliser && (this.fertiliser.Custom || !!this.fertiliser.StandardProduct);
    }

    getImgUrl(): string {
        return "/images/stocks/Solid container.svg";
    }

    getTooltip(): string {
        return this.fertiliser.StandardProduct ? this.fertiliser.StandardProduct.Name : this.description;
    }

    getUnits() {
        var liquid = this.fertiliser.Custom ? this.fertiliser.Liquid : this.fertiliser.StandardProduct.Liquid;
        return liquid ? "l" : "kg";
    }

    private getMainNutrient(): NutrientType {
        var nutrients: boolean[] = [];

        var analysis = this.fertiliser.Custom ? this.fertiliser : this.fertiliser.StandardProduct;

        nutrients[NutrientType.N] = analysis.N && analysis.N > 0;
        nutrients[NutrientType.K2O] = analysis.K2O && analysis.K2O > 0;
        nutrients[NutrientType.MgO] = analysis.MgO && analysis.MgO > 0;
        nutrients[NutrientType.P2O5] = analysis.P2O5 && analysis.P2O5 > 0;
        nutrients[NutrientType.SO3] = analysis.SO3 && analysis.SO3 > 0;

        if (nutrients.filter(n => n).length > 1) return undefined;
        if (nutrients[NutrientType.N]) return NutrientType.N;
        if (nutrients[NutrientType.K2O]) return NutrientType.K2O;
        if (nutrients[NutrientType.MgO]) return NutrientType.MgO;
        if (nutrients[NutrientType.P2O5]) return NutrientType.P2O5;
        if (nutrients[NutrientType.SO3]) return NutrientType.SO3;

        return undefined;
    }
}
